var render = function render(){var _vm=this,_c=_vm._self._c;return _c('split-section',[_c('b-row',[_c('b-col',{staticClass:"py-1"},[_c('h3',[_vm._v("Upcoming Events")])])],1),_vm._l((_vm.events),function(event){return _c('b-row',{key:event.id},[_c('b-col',[_c('event-item',{attrs:{"event":event}})],1)],1)}),(_vm.events.length == 0)?_c('b-row',[_c('b-col',[_vm._v("No upcoming events..")])],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }